<template>
  <div>
    <div class="snapshot" :style="[{ width: iwidth }, { height: iheight }]">
      <img :src="imgSnap || imgDefault || statusImg[status]" alt="" />

      <div class="front" @click="viewModalShow">
        <span v-if="ititle != ''">{{ ititle }}</span>
      </div>
      <div class="bblock">
        <label class="bb_item" :for="$id('fotoId')" @click="inputClick">
          <i class="anticon anticon-file-jpg"></i>
          <input
            type="file"
            class="hiddenFile"
            ref="foto"
            :id="$id('fotoId')"
            name="fotoinput"
            accept="image/*"
            @change="img_change"
          />
        </label>
        <div class="bb_item" @click="webCam">
          <i class="anticon anticon-camera"></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      ref="cameraModal"
      @mousedown.stop="camModalShow"
      :class="{ show: isCamModalShow }"
      :style="[
        isCamModalShow
          ? { display: 'block', paddingRight: '17px' }
          : { display: 'none' },
      ]"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" @mousedown.stop>
          <div class="modal-body">
            <canvas ref="canvas"></canvas>
            <video ref="video" autoplay></video>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="CancelSnap">
              Отмена
            </button>
            <button type="button" class="btn btn-primary" @click="snapShot">
              Снимать
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade viewModal"
      ref="viewModal"
      @mousedown.stop="viewModalShow"
      :class="{ show: isViewModalShow }"
      :style="[
        isViewModalShow
          ? { display: 'block', paddingRight: '17px' }
          : { display: 'none' },
      ]"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow-lg"  @mousedown.stop>
          <div class="btns">
            
            <div class="vClose" @click="viewModalShow">
              <i class="anticon anticon-close"></i>
            </div>
            <div class="editBtn" @click="isCroppedClick" v-if="!isCropped">
              <i class="anticon anticon-edit"></i>
            </div>
            <template v-else>
              <div class="editBtn" @click="isCropped = false">
                <i class="anticon anticon-picture"></i>
              </div>
              <div class="cropBtn" @click="imgCrop">
                <i class="anticon anticon-scissor"></i>
              </div>
              <div class="rtr" @click="mRotate">
                <i class="anticon anticon-redo"></i>
              </div>  
            </template>                                  
          </div>
          
          <div class="modal-body text-center">
            <div v-show="isCropped" class="cropBox">
              <cropper
                :src="img"
                class="cropper"
                :stencil-props="{
                  aspectRatio: aspectRatio
                }"
                ref="cropper"              
                
              />
            
            </div>
            
            <img v-show="!isCropped" :src="photo" alt="" class="imgfluid" @click="showFull" />
          </div>
        </div>
      </div>
      <div class="fullImg" v-show="isfullImg" @click="isfullImg=false" @mousedown.stop>
        <img ref="fullImg" :src="photo" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';

export default {
  name: "FotoBlock",
  components: {Cropper},
  props: {
    imgDefault: {
      type: String,
      default: () => {
        return "";
      },
    },
    iwidth: {
      type: String,
      default: () => {
        return "120px";
      },
    },
    iheight: {
      type: String,
      default: () => {
        return "150px";
      },
    },
    status: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    ititle: {
      type: String,
      default: () => {
        return "";
      },
    },
    aspectRatio: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      cropImage: null,
      isCropped: false,
      img: null,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isfullImg: false,
      cnv: null,
      video: null,
      streeming: false,
      isCamModalShow: false,
      isViewModalShow: false,
      body: null,
      imgSnap: null,
      imgDef: this.imgDefault,
      fotoId: 'id' + Date.now().toString() + Math.floor(Math.random() * 1000).toString(),
      statusImg: [
        require("@/assets/images/others/image.png"),
        require("@/assets/images/others/businessman.svg"),
        require("@/assets/images/others/123.png"),
        require("@/assets/images/others/list2.png"),
      ],
    };
  },
  computed: {
    photo() {
      return this.imgSnap || this.imgDefault
      // return this.statusImg[1];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.cnv = this.$refs.canvas;
      this.video = this.$refs.video;
      this.body = document.querySelector("body");      
    })
  },
  methods: {
    isCroppedClick(){
      this.img = null      
      this.img = this.imgSnap || this.imgDefault
      this.isCropped = !this.isCropped
    },
    imgCrop() {
      const {canvas} = this.$refs.cropper.getResult();
      let dataURL = canvas.toDataURL("image/png");
      this.imgSnap = dataURL;

      this.urltoFile(dataURL, "image.png", "image/png").then((file)=> {
        this.imgSend(file);
      });
      this.isCropped = false
      this.$refs.foto.value = null
		},
    camModalShow() {
      // console.log(navigator.mediaDevices.getUserMedia);
      this.isCamModalShow = !this.isCamModalShow;
      if (this.isCamModalShow) {
        this.body.classList.add("modal-open");
        this.body.style = "padding-right: 17px";
      } else {
        this.body.classList.remove("modal-open");
        this.body.style = "";
      }
    },
    viewModalShow() {
      if (this.imgSnap || this.imgDefault)
        this.isViewModalShow = !this.isViewModalShow;
      if (this.isViewModalShow) {
        this.body.classList.add("modal-open");
        this.body.style = "padding-right: 17px";
      } else {
        this.body.classList.remove("modal-open");
        this.body.style = "";
      }
      this.isCropped = false
    },
    // async streem(){
    //   if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
    //     let vv = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
    //     this.video.srcObject = vv;
    //     this.video.paly()
    //     console.log(navigator.mediaDevices);
    //   }
    // }
    webCam() {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            facingMode: "user",
            audio: false,
            video: true,
          })
          .then((stream) => {
            this.video.srcObject = stream;
            this.video.muted = true;
            this.video.play();
            this.streeming = true;
            this.camModalShow();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    snapShot() {
      if (this.streeming) {
        this.cnv.width = this.video.clientWidth;
        this.cnv.height = this.video.clientHeight;
        let ctx = this.cnv.getContext("2d");
        ctx.drawImage(this.video, 0, 0, this.cnv.width, this.cnv.height);
        let dataURL = this.cnv.toDataURL("image/png");

        // console.log(this.cnv.width);
        this.imgSnap = dataURL;
        this.$refs.foto.value = null

        this.urltoFile(dataURL, "image.png", "image/png").then((file)=> {
          this.imgSend(file);
        });
        this.camModalShow();
      }
    },
    async urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
    CancelSnap() {
      this.camModalShow();
      this.imgSnap = null;
      this.imgSend(null);
      this.video.pause();
    },

    img_change(event) {
      let file = event.target.files[0];
      if (file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgSnap = reader.result;
          // console.log(this.imgSnap);
          // this.imgSend(this.imgSnap)
        };
        this.imgSend(file);
      } else {
        this.imgSnap = null;
        this.imgSend(null);
        event.target.value = null;
      }
      
    },
    imgSend(img) {
      this.$emit("img64", img);
    },
    mRotate(){      
      this.$refs.cropper.rotate(90)
      
    },

    showFull(){
      this.isfullImg=true
    },
    inputClick(){
      // this.$refs.fotoId.value = null
    }
 
  },
  
};
</script>

<style lang="scss" scoped>
.snapshot {
  width: 100%;
  height: 150px;
  border: 1px dashed #cdd9e9;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
  .front {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color: #67a9ff, $alpha: 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    opacity: 0;
    transition: 0.2s;
    cursor: pointer;
  }
  .bblock {
    position: absolute;
    top: 0;
    right: 0;
    .bb_item {
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2em;
      height: 2em;
      background-color: rgba($color: #3f87f5, $alpha: 0.7);
      color: #fff;
      cursor: pointer;
      transition: 0.2s;
      &:first-child {
        border-left: 1px solid transparent;
      }
      &:last-child {
        border-radius: 0 0 0 5px;
        border-left: 1px solid transparent;
        border-bottom: 1px solid transparent;
      }
      .hiddenFile {
        position: absolute;
        width: 0.1px;
        height: 0.1px;
        z-index: -1;
        opacity: 0;
      }
    }
  }
  &:hover {
    // border-color: #3f87f5;
    border: 1px solid #3f87f5;
    .front {
      opacity: 1;
    }
    .bblock {
      .bb_item {
        background-color: rgba($color: #3f87f5, $alpha: 1);
        &:hover {
          background-color: #fff;
          color: #3f87f5;
          border-color: #3f87f5;
        }
      }
    }
  }
}
.modal {
  background-color: rgba(0, 0, 0, 0.7);
}
.modal-body {
  padding: 0;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  position: relative;
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    // right: 0;bottom: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.viewModal .modal-body {
  border-radius: 5px 5px 5px 5px;
  padding: 10px;
}
.modal-content{
  transition: transform .3s;
}
.btns{
  position: absolute;  
  transition: .3s;
  width: 0;
  height: 0;
  right: -10px;
  top: -35px; 
  
  .rtr, .vClose, .cropBtn, .editBtn {
    width: 2em;
    height: 2em;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 20px 0 rgba($color: #000000, $alpha: 0.3);
    transition: 0.1s;
    margin-bottom: 7px;    
  }

  .rtr:hover{
    background-color: rgb(26, 163, 13);
    color: #fff;
  }
  .vClose:hover {
    background-color: rgb(197, 26, 26);
    color: #fff;
  }
  .editBtn:hover, .cropBtn:hover{
    background-color: rgb(37, 104, 192);
    color: #fff;
  }
  
}
.imgfluid{
  max-width: 100%;
  height: auto;
  cursor: -webkit-zoom-in;
}
.fullImg{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1052;
  // display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: -webkit-zoom-out;
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.cropper{
  width: 100%;
  background-color: #eee;
}

</style>
